module.exports = __webpack_public_path__ + "0caf7493c9f01c9596ac9815a31a3f27.svg";